import React, { useState } from 'react';
import {
  Layout,
  Card,
  Button,
  Select,
  TextField,
} from '@shopify/polaris';

import Container from 'components/Container';
import {adjustUserToken} from 'api/user';

const AdjustCustomerToken = () => {

  const [customerId, setCustomerId] = useState(null);
  const [action, setAction] = useState('add');
  const [tokens, setTokens] = useState(null);

  const submit = async () => {
    if(!customerId || !tokens) {
      alert('Please enter customer ID and tokens');
    } else {
      await adjustUserToken(customerId, action, tokens);
      setCustomerId(null);
      setAction('add');
      setTokens(null);
      alert('Successfully adjusted customer tokens');
    }
  }

  const options = [
    {label: 'Add', value: 'add'},
    {label: 'Remove', value: 'remove'},
  ];
  return (
    <Container pageProps={{
      title: 'Adjust token for customer',
      subtitle: 'This will adjust the customer tokens',
      fullWidth: true,
    }}>
      <React.Fragment>
        <Layout.Section>
          <Card sectioned>
            <div style={{gridTemplateColumns: '1fr 1fr 1fr', gap: 20, display: 'grid'}}>
              <TextField helpText="Enter Customer Shopify Id" type="text" label="Customer Id" value={customerId} onChange={value => setCustomerId(value)} />
              <Select
                label="Action"
                options={options}
                onChange={action => setAction(action)}
                value={action}
              />
              <TextField type="number" label="Number of tokens" value={tokens} onChange={tokens => setTokens(tokens)} />
            </div>
            <br />
            <div style={{display: 'flex', gap: 20}}>
              <Button primary onClick={submit}>Submit</Button>
            </div>
          </Card>
        </Layout.Section>
      </React.Fragment>
    </Container>
  );
}

export default AdjustCustomerToken;
